import { useCallback } from "react";
import { axiosUser } from "../axios";
import type { IFindUsersQuery, TFindUsersResponse } from "./types";

export const useFindUsersPartner = () => {
  const [state, execute, cancel] = axiosUser<TFindUsersResponse, void, unknown>(
    {
      url: "/partner",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query?: IFindUsersQuery) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
